import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getLanguageLocalStorage } from '../../../../helpers/localStorage';
import { ErrorChecker } from '../../../../stores/helpers/ErrorChecker';

import type { ThunkConfig } from '../../../../stores/types';
import { getOrganizationDTO } from '../../dto/getOrganization.dto';

type GetOrganizationListRequestParams = { sort?: string; sortDirection?: string; search?: string };

export const getOrganizationListAsync = createAsyncThunk<
  getOrganizationDTO,
  GetOrganizationListRequestParams | void,
  ThunkConfig
>(
  'oranization/getOrganization',

  async (params: GetOrganizationListRequestParams | void, { rejectWithValue }) => {
    try {
      const language = getLanguageLocalStorage();

      const { data } = await axios.get<{ data: getOrganizationDTO }>(`/private/organizations/get`, {
        headers: {
          'Accept-Language': language,
        },
        params,
      });

      return data.data;
    } catch (err) {
      return rejectWithValue(ErrorChecker(err));
    }
  },
);
